import {Row,Col,Button} from "reactstrap";
import Sidebar from '../../Sidebar';
import { useParams, useLocation, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useCookies } from 'react-cookie';
import { getCubeTestReportDetails,updateCubeTestReport,deleteCubeTestReport,cancelCubeTestReport, getPendingCubeTestReports, closePendingCubeTestReport, unlockCubeTestReport } from '../../services/CubeTestReportServices';
import TableRowsCubeTestReportEdit from "./TableRowsCubeTestReportEdit";
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import React from 'react';
import { useState, useEffect ,useMemo} from "react";
import Swal from "sweetalert2";
import { getUserAllowedPlants } from '../../services/PlantServices';
import { displayError } from '../../helpers';
import { getDisplayDate } from '../../utils/DateUtils';
import ReactTablePopUpSubmitWrapper from "../../components/ReactTablePopUpSubmitWrapper";
import CubeTestReportSelectionBanner from './CubeTestReportSelectionBanner';
import CubeTestReportAgePanel from './CubeTestReportAgePanel';
import {
  showDcGroupPop,
  getCubeStrengthResult,
  isCubeTestValueFulfilled,
  buildCubeIdFromSelection,
  buildCubeSampleId,
  buildReportListPayload,
  buildPendingAgeRow,
  syncCubeIdsForAgeRows,
  applyAgeRowFieldChange,
  resolveNextAgeDays,
  resolveCuredPlaceFromAgeRows,
  castingDateInputFromApi,
  reportDateFromCastingAndAge,
  mergeCsrRowsForAge,
  generateAndMergeCsrRowsForAge,
} from './CubeTestReportUtils';
import {
  buildPendingListTitle,
  decoratePendingRecords,
  getPendingColumns,
  getPendingQueryRange,
  mapAllowedPlants,
} from './cubeTestReportDefaults';
import PremiumPageHeader from '../../components/PremiumPageHeader';

function toInputDate(value) {
  if (!value) {
    return '';
  }
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
    return raw.slice(0, 10);
  }
  const parts = raw.split(/[-/]/);
  if (parts.length === 3 && parts[2].length === 4) {
    return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
  }
  return raw;
}

function resolveAgeDays(castingDisplay, reportDisplay, fallback = 7) {
  const casting = toInputDate(castingDisplay);
  const report = toInputDate(reportDisplay);
  if (!casting || !report) {
    return fallback;
  }
  const castingDate = new Date(`${casting}T00:00:00`);
  const reportDate = new Date(`${report}T00:00:00`);
  if (Number.isNaN(castingDate.getTime()) || Number.isNaN(reportDate.getTime())) {
    return fallback;
  }
  const diff = Math.round((reportDate - castingDate) / (24 * 60 * 60 * 1000));
  if (diff === 7 || diff === 28) {
    return diff;
  }
  return fallback;
}

function buildAgeSetupRowsFromDetails(detailRows, selection, castingDt, curedPlace) {
  const ageMap = {};
  (detailRows || []).forEach((row) => {
    const age = Number(row.age);
    if (!ageMap[age]) {
      ageMap[age] = {
        age,
        no_of_moulds: 0,
        cured_place: curedPlace || 'plant',
        cube_id: buildCubeIdFromSelection(selection, age, castingDt),
      };
    }
    ageMap[age].no_of_moulds += 1;
  });
  return Object.values(ageMap);
}

function CubeTestReportEdit() {
  const {id}=useParams()
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const pendingAgeFromQuery = Number(searchParams.get('pendingAge'));
  const pendingAgeFromState = location.state?.pendingAge
    ? Number(location.state.pendingAge)
    : null;
  const pendingAgeFromRoute = (pendingAgeFromQuery === 7 || pendingAgeFromQuery === 28)
    ? pendingAgeFromQuery
    : (pendingAgeFromState === 7 || pendingAgeFromState === 28)
      ? pendingAgeFromState
      : null;
  const [cookies] = useCookies(['myToken']);
  const [inputs, setInputs] = useState({});
  const [inProgress, setInProgress] = useState(false);
  const [dcGroup,setDcGroup]=useState([]);
  const [SelectedDcGroup,setSelectedDcGroup]=useState({});
  const [showPendingModal, setShowPendingModal] = useState(false);
  const [pendingModalTitle, setPendingModalTitle] = useState('');
  const [pendingAgeDays, setPendingAgeDays] = useState(pendingAgeFromRoute);
  const [plants, setPlants] = React.useState([]);
  const [csrRows, setCsrRows] = useState([]);
  const [rowsData, setRowsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pendingTestAge, setPendingTestAge] = useState(pendingAgeFromRoute);
  const [hasDay7Completed, setHasDay7Completed] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [closedReason, setClosedReason] = useState('');
       
  React.useEffect(() => {
    //Load data for Plant dropdown
    getUserAllowedPlants(cookies)
    .then (
      plantList => {
        const plants = mapAllowedPlants(plantList);
        setPlants(plants);
      }
    )
  }, []); 

  React.useEffect(() => {
    if (id) {
      setInProgress(true);
      getCubeTestReportDetails(cookies, id)
        .then(response => {
          setInProgress(false);
          setIsClosed(!!response.is_closed);
          setClosedReason(response.closed_reason || '');
          setInputs(values => ({ ...values,
              id:response.id,
              plant_id:response.plant.id,
              user_remarks:response.user_remarks,
              cured_place:response.cured_place,
              cube_test_report_no:response.cube_test_report_no,
              csr_no:`${response.prefix || ''}${response.cube_test_report_no || ''}`,
              csr_date:getDisplayDate(response.cube_test_report_date),
              prefix:response.prefix,
              supplied_qty:response.supplied_qty,
              casting_dt:getDisplayDate(response.casting_dt),
              technician_name:response.technician_name,
              cement_type:response.cement_type,
              cement_content:response.cement_content,
              no_of_moulds:response.no_of_moulds}))
          // Create a map to count occurrences of each `age`
          const detailList = response.detail_list || [];
          const ageCountMap = detailList.reduce((map, item) => {
              map[item.age] = (map[item.age] || 0) + 1;
              return map;
          }, {});
          console.log(JSON.stringify(ageCountMap)+"ageCountMap");
          // Add the `no_of_rows` property to each object
          let updatedDetailList = detailList.map((item,index) => {
            var per_csr = item.age/(4.7+(0.832*(item.age)))*100;
            var grade =response.grade.grade_number;
            var cube_strength = (parseInt(grade)*per_csr/100).toFixed(2);
            item['act_strength_result'] = getCubeStrengthResult(item.act_strength, cube_strength);
            item['cus_strength_result'] = getCubeStrengthResult(item.cus_strength, cube_strength);
            item['act_result'] = getCubeStrengthResult(item.act_average, cube_strength);
            item['cus_result'] = getCubeStrengthResult(item.cus_average, cube_strength);
            item['ref_cube_strength']=cube_strength;
            return {
            ...item,
            age_date: toInputDate(item.age_date),
            no_of_rows: ageCountMap[item.age],
            sl_no :index + 1,
          }});

          // If master exists but detail rows were not saved (e.g. sample_id length),
          // rebuild editable cube rows so the data table is visible.
          if (!updatedDetailList.length && Number(response.no_of_moulds) > 0) {
            const mouldCount = Number(response.no_of_moulds) || 3;
            const ageDays = pendingAgeFromRoute
              || resolveAgeDays(response.casting_dt, response.cube_test_report_date, 7);
            const customerName = response.consignee?.customer?.name || '';
            const gradeName = response.grade?.name || '';
            const castingInput = toInputDate(getDisplayDate(response.casting_dt));
            const baseCubeId = buildCubeIdFromSelection(
              { customer_name: customerName, product_name: gradeName },
              ageDays,
              castingInput || response.casting_dt,
            );
            const testingDate = (() => {
              const base = castingInput
                ? new Date(`${castingInput}T00:00:00`)
                : new Date();
              base.setDate(base.getDate() + ageDays);
              const y = base.getFullYear();
              const m = String(base.getMonth() + 1).padStart(2, '0');
              const d = String(base.getDate()).padStart(2, '0');
              return `${y}-${m}-${d}`;
            })();
            updatedDetailList = Array.from({ length: mouldCount }, (_, rowIndex) => ({
              id: null,
              sl_no: rowIndex + 1,
              age: ageDays,
              sample_id: buildCubeSampleId(baseCubeId, rowIndex + 1, mouldCount) || `${baseCubeId}${rowIndex + 1}`,
              age_date: testingDate,
              no_of_rows: mouldCount,
              act_weight: 0,
              act_load: 0,
              act_strength: 0,
              act_average: 0,
              act_difference: 0,
              act_result: 'PENDING',
              act_strength_result: 'PENDING',
              cus_weight: 0,
              cus_load: 0,
              cus_strength: 0,
              cus_average: 0,
              cus_difference: 0,
              cus_result: 'PENDING',
              cus_strength_result: 'PENDING',
              user_remarks: '',
              ref_cube_strength: 0,
            }));
          }

          let reportRows = updatedDetailList;
          const day7Done = updatedDetailList.some(
            (item) => Number(item.age) === 7 && (
              isCubeTestValueFulfilled(item.act_average)
              || isCubeTestValueFulfilled(item.act_load)
              || isCubeTestValueFulfilled(item.act_strength)
            )
          );
          setHasDay7Completed(day7Done);

          setSelectedDcGroup({id:1,project_name:response.consignee.project_name,
            customer_name:response.consignee.customer.name,
            marketing_name: response.consignee.customer.salesrep?.alias
              || response.consignee.customer.salesrep?.name,
            total_dc_qty:response.supplied_qty,
            delivery_challan_date:response.casting_dt,
            product_name:response.grade.name,
            grade_number:response.grade.grade_number,
            dc_ids_list:response.dc_ids_list,
            customer_id:response.consignee.customer.id,
            consignee_id:response.consignee.id,
            product_id:response.grade.id})

          const castingInput = toInputDate(getDisplayDate(response.casting_dt))
            || toInputDate(response.casting_dt);
          const selectionForIds = {
            customer_name: response.consignee?.customer?.name || '',
            product_name: response.grade?.name || '',
          };

          // From pending list (e.g. 28 Days Pending): keep saved 7-day rows visible,
          // and prepare Age panel only for the missing pending age so user can Generate.
          if (pendingAgeFromRoute) {
            const ageRows = updatedDetailList.filter(
              (item) => Number(item.age) === Number(pendingAgeFromRoute)
            );
            const ageFulfilled = ageRows.some(
              (item) => isCubeTestValueFulfilled(item.act_average)
                || isCubeTestValueFulfilled(item.act_load)
                || isCubeTestValueFulfilled(item.act_strength)
            );
            if (!ageFulfilled) {
              const cubeId = buildCubeIdFromSelection(
                selectionForIds,
                pendingAgeFromRoute,
                castingInput || response.casting_dt,
              );
              setRowsData(syncCubeIdsForAgeRows(
                [buildPendingAgeRow(
                  pendingAgeFromRoute,
                  cubeId,
                  response.cured_place || 'plant',
                )],
                selectionForIds,
                castingInput || response.casting_dt,
              ));
              setInputs((values) => ({
                ...values,
                pending_age_days: pendingAgeFromRoute,
                casting_dt: castingInput || values.casting_dt,
              }));
              setPendingTestAge(pendingAgeFromRoute);
              Swal.fire(
                `${pendingAgeFromRoute}-day test pending`,
                day7Done
                  ? `Existing 7-day results are shown. Enter moulds for ${pendingAgeFromRoute}-day, click Generate on that age row, fill values and save.`
                  : `Enter moulds for ${pendingAgeFromRoute}-day, click Generate on that age row, fill values and save.`,
                'info'
              );
            } else {
              setRowsData(buildAgeSetupRowsFromDetails(
                reportRows,
                selectionForIds,
                castingInput,
                response.cured_place || 'plant',
              ));
            }
          } else {
            setRowsData(buildAgeSetupRowsFromDetails(
              reportRows,
              selectionForIds,
              castingInput,
              response.cured_place || 'plant',
            ));
          }
          setCsrRows(reportRows);
        }).catch(error => {
          setInProgress(false);
          displayError(error.response.data, "Loading Failed");
        });
    }
  }, [cookies, id, pendingAgeFromRoute]);     

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    // console.log(name+"name")
    // console.log(value+"value")   
    setInputs(values => ({ ...values, [name]: value })) 
  }

  const navigate = useNavigate();

  const view = () => {
      navigate('/CubeTestReportTable')
  }  
      
  const Back = () => {
    navigate('/Home')
  }

  const Cancel = () => {
    navigate('/Cancel')
  }
      
  const handleChangeCsr = (index, evnt)=>{
        const { name, value } = evnt.target;
        const CsrRowsInput = [...csrRows];
        CsrRowsInput[index][name] = value;
        if (name==='act_load' || name === 'cus_load'){
          const strength=(value/22.5).toFixed(2);
          const age =parseInt(CsrRowsInput[index]['age']);
          const no_of_rows =CsrRowsInput[index]['no_of_rows'];
          var total = parseFloat(strength);
          var per_csr = age/(4.7+(0.832*age))*100;
          var grade =SelectedDcGroup.grade_number;
          // console.log(grade+"grade");
          var cube_strength = (parseInt(grade)*per_csr/100).toFixed(2);
          CsrRowsInput[index]['ref_cube_strength']=cube_strength;
          CsrRowsInput.map((row,row_index)=>{
            // console.log(JSON.stringify(row)+"row"+row_index+"row_index");
            if((parseInt(row['age']) === age) && (row_index != index)){
              if (name==='act_load'){
              total+= parseFloat(row['act_strength'])
              }
              else{
                total+= parseFloat(row['cus_strength'])
              }
            }
          })
          var average = (total/no_of_rows).toFixed(2);
          CsrRowsInput.map((row_1,row_index_1)=>{
            // console.log(JSON.stringify(row)+"row"+row_index+"row_index");
            if(parseInt(row_1['age']) === age){
              if (name==='act_load'){
                CsrRowsInput[index]['act_strength'] = strength;
                CsrRowsInput[row_index_1]['act_average'] = average;
                CsrRowsInput[row_index_1]['act_difference']= (parseFloat(average)-CsrRowsInput[row_index_1]['act_strength']).toFixed(2);
                CsrRowsInput[index]['cus_load'] = value;
                CsrRowsInput[index]['cus_strength'] = strength;
                CsrRowsInput[row_index_1]['cus_average'] = average;
                CsrRowsInput[row_index_1]['cus_difference']= (parseFloat(average)-CsrRowsInput[row_index_1]['act_strength']).toFixed(2);
                CsrRowsInput[index]['act_strength_result'] = getCubeStrengthResult(strength, cube_strength);
                CsrRowsInput[index]['cus_strength_result'] = getCubeStrengthResult(strength, cube_strength);
                CsrRowsInput[row_index_1]['act_result'] = getCubeStrengthResult(average, cube_strength);
                CsrRowsInput[row_index_1]['cus_result'] = getCubeStrengthResult(average, cube_strength);
            }
            else{
              CsrRowsInput[index]['cus_strength'] = strength;
              CsrRowsInput[row_index_1]['cus_average'] = average;
              CsrRowsInput[row_index_1]['cus_difference']= (parseFloat(average)-CsrRowsInput[row_index_1]['cus_strength']).toFixed(2);
              CsrRowsInput[index]['cus_strength_result'] = getCubeStrengthResult(strength, cube_strength);
              CsrRowsInput[row_index_1]['cus_result'] = getCubeStrengthResult(average, cube_strength);
            }
            }
          })
          // console.log(total+"total");
        }
        else if(name==='act_weight'){
          CsrRowsInput[index]['cus_weight'] = value;
        }
        // console.log(JSON.stringify(CsrRowsInput)+"CsrRowsInput");
        setCsrRows(CsrRowsInput);
  }

  const ClosePending = () => {
    setShowPendingModal(false);
  };

  const openPendingList = (ageDays) => {
    if (!inputs.plant_id) {
      Swal.fire('Plant is not loaded yet.', '', 'info');
      return;
    }
    const queryRange = getPendingQueryRange(ageDays);
    setIsLoading(true);
    setPendingAgeDays(ageDays);
    setPendingTestAge(ageDays);
    getPendingCubeTestReports(cookies, inputs.plant_id, ageDays, {
      fromDate: queryRange.fromDate.format('DD-MM-YYYY'),
      uptoDate: queryRange.uptoDate.format('DD-MM-YYYY'),
    })
      .then((response) => {
        const tableData = decoratePendingRecords(response.pending_list);
        setDcGroup(tableData);
        setPendingModalTitle(buildPendingListTitle(ageDays, queryRange.fromDate, queryRange.uptoDate));
        setShowPendingModal(true);
        setIsLoading(false);
        if (!tableData.length) {
          Swal.fire(
            `No pending ${ageDays}-day records found for this plant in the last 90 days.`,
            '',
            'info',
          );
        }
      })
      .catch((error) => {
        setIsLoading(false);
        displayError(error.response?.data, ' Failed');
      });
  };

  const handlePendingRowSelect = (value) => {
    const selected = dcGroup.find((obj) => obj.id == value);
    if (!selected) {
      return;
    }
    if (selected.pending_type === 'update' && selected.csr_id && String(selected.csr_id) !== String(id)) {
      setShowPendingModal(false);
      navigate(`/CubeTestReportEdit/${selected.csr_id}?pendingAge=${pendingAgeDays || 28}`, {
        state: { pendingAge: pendingAgeDays || 28, fromPending: true },
      });
      return;
    }
    applyPendingSelectionToEdit(selected);
  };

  const handlePendingRowClose = (value) => {
    const selected = dcGroup.find((obj) => obj.id == value);
    if (!selected) {
      return;
    }
    const defaultReason = selected.suggest_close
      ? `Cube test not required — ${selected.product_name || 'low grade'}`
      : `Closed without cube test — ${selected.product_name || 'grade'}`;
    Swal.fire({
      title: 'Close pending report?',
      html: `Mark this pending item as <b>not required</b> / closed.`,
      input: 'text',
      inputLabel: 'Reason',
      inputValue: defaultReason,
      showCancelButton: true,
      confirmButtonText: 'Close',
      confirmButtonColor: '#b45309',
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      const payload = selected.pending_type === 'update' && selected.csr_id
        ? {
            csr_id: selected.csr_id,
            closed_reason: result.value || defaultReason,
          }
        : {
            plant_id: inputs.plant_id,
            casting_dt: selected.delivery_challan_date,
            product_id: selected.product_id,
            consignee_id: selected.consignee_id,
            customer_id: selected.customer_id,
            dc_ids_list: selected.dc_ids_list || [],
            total_dc_qty: selected.total_dc_qty,
            closed_reason: result.value || defaultReason,
          };
      setIsLoading(true);
      closePendingCubeTestReport(cookies, payload)
        .then((response) => {
          Swal.fire('Closed', `Report ${response.report_no || ''} marked as not required.`, 'success');
          openPendingList(pendingAgeDays || 7);
        })
        .catch((error) => {
          setIsLoading(false);
          displayError(error?.response?.data || error, 'Close Failed');
        });
    });
  };

  const onUnlockCubeTestReport = () => {
    Swal.fire({
      title: 'Unlock closed report?',
      text: 'You can then enter cube test readings and generate the PDF.',
      showCancelButton: true,
      confirmButtonText: 'Unlock',
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      setInProgress(true);
      unlockCubeTestReport(cookies, id)
        .then(() => {
          setIsClosed(false);
          setClosedReason('');
          setInProgress(false);
          Swal.fire('Unlocked', '', 'success');
        })
        .catch((error) => {
          setInProgress(false);
          displayError(error?.response?.data || error, 'Unlock Failed');
        });
    });
  };

  const applyPendingSelectionToEdit = (selected) => {
    if (!selected) {
      return;
    }
    if (selected.pending_type === 'update' && selected.csr_id && String(selected.csr_id) !== String(id)) {
      setShowPendingModal(false);
      navigate(`/CubeTestReportEdit/${selected.csr_id}?pendingAge=${pendingAgeDays || 28}`, {
        state: { pendingAge: pendingAgeDays || 28, fromPending: true },
      });
      return;
    }

    const ageDays = pendingAgeDays || pendingTestAge || 7;
    const castingDt = castingDateInputFromApi(selected.delivery_challan_date) || inputs.casting_dt;
    const reportDate = reportDateFromCastingAndAge(castingDt, ageDays);
    const cubeId = buildCubeIdFromSelection(selected, ageDays, castingDt);
    setSelectedDcGroup({
      ...selected,
      id: selected.id || 1,
    });
    setInputs((values) => ({
      ...values,
      casting_dt: castingDt || values.casting_dt,
      csr_date: reportDate || values.csr_date,
      pending_age_days: ageDays,
      cured_place: values.cured_place || 'plant',
    }));
    setRowsData(syncCubeIdsForAgeRows(
      [buildPendingAgeRow(ageDays, cubeId, inputs.cured_place || 'plant')],
      selected,
      castingDt,
    ));
    setShowPendingModal(false);
  };

  const generateCubeRowsForAgeRow = async (rowIndex) => {
    if (!inputs.casting_dt || !SelectedDcGroup.grade_number) {
      Swal.fire('Please choose casting date and delivery challan.', '', 'info');
      return;
    }
    const row = rowsData[rowIndex];
    if (!row) {
      return;
    }
    const moulds = parseInt(row.no_of_moulds, 10) || 0;
    if (!moulds) {
      Swal.fire('Please enter mould count for this age row.', '', 'info');
      return;
    }
    if (!row.cured_place) {
      Swal.fire('Please select mould casting area for this row.', '', 'info');
      return;
    }
    const { merged, cancelled, empty } = await generateAndMergeCsrRowsForAge({
      existingCsrRows: csrRows,
      ageRow: row,
      castingDateInput: inputs.casting_dt,
      mode: 'edit',
    });
    if (cancelled) {
      return;
    }
    if (empty) {
      Swal.fire('Could not generate cube rows for this age.', '', 'info');
      return;
    }
    setCsrRows(merged);
    setInputs((values) => ({
      ...values,
      no_of_moulds: merged.length,
      cured_place: resolveCuredPlaceFromAgeRows(rowsData, values.cured_place),
    }));
  };

  const agePanelVisible = Boolean(inputs.casting_dt && SelectedDcGroup.grade_number);

  React.useEffect(() => {
    if (!SelectedDcGroup?.customer_name || !rowsData.length) {
      return;
    }
    setRowsData((current) => syncCubeIdsForAgeRows(current, SelectedDcGroup, inputs.casting_dt));
  }, [SelectedDcGroup?.customer_name, SelectedDcGroup?.product_name, inputs.casting_dt]);
 
  const onCancelCubeTestReport = (event) => {
    event.preventDefault();
    Swal.fire({title: 'Do you want to cancel the Cube test report?',  
    showCancelButton: true,  
    confirmButtonText: `Yes`,
    cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 
        setIsLoading(true);
        cancelCubeTestReport(cookies, id)
        .then(response => {
            console.log(`cube test report with id ${id} canceled`);
            Swal.fire('Cancelled Successfully!', '', 'success');
            view();
        })
        .catch(error => {
            console.log(error.response.data);
            displayError(error.response.data,'Cancel Failed');
        }); 
      }
      else if (result.isDismissed) {    
        Swal.fire('Not Canceled', '', 'info')  
      }
    });
  };

  const onDeleteCubeTestReport = (event) => {
    event.preventDefault();
    Swal.fire({title: 'Are you sure to Delete?',  
    showCancelButton: true,  
    confirmButtonText: `Yes`,  
    cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 
        setIsLoading(true);
        deleteCubeTestReport(cookies, id)
        .then(response => {
            // console.log(`CTR with id ${id} deleted`);
            Swal.fire('Deleted Successfully!', '', 'success');
            view();
        })
        .catch(error => {
            // console.log(error.response.data);
            displayError(error.response.data,'Delete Failed');
        }); 
      } else if (result.isDismissed) {    
        Swal.fire('Not Deleted', '', 'info')  
      }
    });
  };

  const deleteTableRows = (index) => {
    const removed = rowsData[index];
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
    if (removed?.age != null && removed.age !== '') {
      setCsrRows((current) => mergeCsrRowsForAge(current, [], removed.age));
    }
  };

  const showDcDetails = () => {
    if (SelectedDcGroup.id) {
      showDcGroupPop(SelectedDcGroup);
    }
  }

  const handletableChange = (index, evnt) => {
    const { name, value } = evnt.target;
    setRowsData(applyAgeRowFieldChange(rowsData, index, name, value, SelectedDcGroup, inputs.casting_dt));
  };

  const addTableRows = () => {
    const pendingAge = inputs.pending_age_days || pendingTestAge || pendingAgeFromRoute || 7;
    const nextAge = resolveNextAgeDays(rowsData, pendingAge);
    const defaultCubeId = buildCubeIdFromSelection(SelectedDcGroup, nextAge, inputs.casting_dt);
    const defaultCuredPlace = rowsData[0]?.cured_place || inputs.cured_place || 'plant';
    setRowsData([
      ...syncCubeIdsForAgeRows(rowsData, SelectedDcGroup, inputs.casting_dt),
      buildPendingAgeRow(nextAge, defaultCubeId, defaultCuredPlace),
    ]);
  };

  const handleSubmit=(event)=> {
    event.preventDefault();
    if (isClosed) {
      Swal.fire('Unlock this closed report before updating cube test readings.', '', 'info');
      return;
    }
    console.log(JSON.stringify(inputs)+"inputs submit");
    console.log(JSON.stringify(csrRows)+csrRows.length+"csrRows");
    if(inputs.no_of_moulds > 0){
      Swal.fire({title: 'Do you want to Update?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 
            console.log("can submit");
            updateCubeTestReport(cookies, {
              id:inputs.id,
              plant_id:inputs.plant_id,
              customer_id:SelectedDcGroup.customer_id,
              consignee_id:SelectedDcGroup.consignee_id,
              grade:SelectedDcGroup.product_id,
              dc_ids_list:SelectedDcGroup.dc_ids_list,
              supplied_qty:SelectedDcGroup.total_dc_qty,
              report_no:inputs.cube_test_report_no,
              report_date:getDisplayDate(inputs.csr_date),
              prefix:inputs.prefix,
              casting_dt:getDisplayDate(inputs.casting_dt),
              technician_name:inputs.technician_name?inputs.technician_name:'',
              cement_type:inputs.cement_type?inputs.cement_type:'',
              cured_place: resolveCuredPlaceFromAgeRows(rowsData, inputs.cured_place) || inputs.cured_place || '',
              cement_content:inputs.cement_content?inputs.cement_content:'',
              no_of_moulds:inputs.no_of_moulds?parseInt(inputs.no_of_moulds):0,
              user_remarks:inputs.user_remarks,
              report_list: buildReportListPayload(csrRows, {
                mode: 'edit',
                formatDate: getDisplayDate,
              }),
            },id)
            .then(response => {
                Swal.fire("Updated!", "", "success");
                view();
            }).catch((error) => {
                displayError(error.response.data,"Update Failed");
            });
          } 
          else if (result.isDismissed) 
          {    
            Swal.fire('Not updated', '', 'info')  
          }
        });
    }
    else{
      Swal.fire('No of moulds must be greater than 0', '', 'info')  
    }
  }
    
  const pendingColumns = useMemo(() => getPendingColumns(true), []);

  return (
      <>
        <div id="outer-container"  className="App" > 
          <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} data-id={inputs.id}/>
          <LoadingOverlay inProgress={inProgress}/>
          <div id="page-wrap">
            <form onSubmit={handleSubmit} data-id={inputs.id}>
              <div className="premium-page-header-wrap">
              <PremiumPageHeader
                module="QUALITY CONTROL"
                title="Update Compressive Strength Report"
                subtitle="Edit cube test readings and remarks. Use Print to preview the report PDF."
                modeLabel="EDIT MODE"
              />
            </div>

              <FloatingControls tableLink="/CubeTestReportTable" formLink="/CubeTestReport" addNewLabel="New Cube Test Report" enableCancel={false}/>
              <div className="form-content-wrap">
                {isClosed ? (
                  <div className="alert alert-warning" role="alert" style={{ margin: '12px 16px' }}>
                    <strong>Closed — Not Required.</strong>
                    {' '}
                    {closedReason || 'Cube test was marked as not required.'}
                    {' '}
                    Unlock to enter readings and generate the report.
                    <div style={{ marginTop: 8 }}>
                      <Button color="warning" type="button" onClick={onUnlockCubeTestReport}>
                        Unlock
                      </Button>
                    </div>
                  </div>
                ) : null}
                <CubeTestReportSelectionBanner selection={SelectedDcGroup} />
                <Row className="form-equal-height-row no-gutters">
                  <Col xl={6} lg={12} md={12}>
                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill">
                      <label htmlFor="plant_id" className="form-group col-sm-4 text-right">Plant Location</label>
                      <select id="plant_id" name="plant_id" className="form-control col-sm-7  browser-default custom-select" style={{ backgroundColor: "white", cursor: "not-allowed" }} disabled={true} value={inputs.plant_id || ""}>
                        <option value="">Select Plant</option>
                        {plants.map((item) => (
                          <option key={item.value} value={item.value}>
                                              {item.label}</option>
                        ))}
                      </select><br />

                      <label className="form-group col-sm-4 text-right">Pending Tests</label>
                      <div className="form-group col-sm-7" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => openPendingList(7)}
                        >
                          7 Days Pending
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => openPendingList(28)}
                        >
                          28 Days Pending
                        </button>
                      </div>
                      <br />

                      <div className="modal" tabIndex="-1" style={{ display: showPendingModal ? 'block' : 'none' }}>
                        <div className="modal-dialog modal-xl" style={{height: "500px"}} >
                          <div className="modal-content">
                              <div className="modal-body display">
                                <div className="container item-list-table-container">
                                  <ReactTablePopUpSubmitWrapper
                                      title={pendingModalTitle || 'Pending Cube Tests'}
                                      columns={pendingColumns}
                                      data={dcGroup}
                                      onRowSubmit={handlePendingRowSelect}
                                      onRowClose={handlePendingRowClose}
                                      isLoading={isLoading}
                                      onClose={ClosePending}
                                  />
                                </div> 
                              </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </Col>
              
                  <Col xl={6} lg={12} md={12}>
                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel form-panel-fill">
                      <label htmlFor="csr_no" className="form-group col-sm-4 text-right">Report No</label>
                      <input type="text" className="form-control col-sm-7" id="csr_no" value={inputs.csr_no || ""} style={{cursor: "not-allowed"}} disabled={true} name="csr_no"  /><br />
                      
                      <label htmlFor="csr_date" className="form-group col-sm-4 text-right ">Date</label>
                      <input
                        type="date"
                        id="csr_date"
                        name="csr_date"
                        className="form-control col-sm-7 mandatory-form-control"
                        value={inputs.csr_date || ""}
                        onChange={handleChange}
                        required
                      />

                      {SelectedDcGroup.dc_details?.length ? (
                        <>
                          <label className="form-group col-sm-4 text-right"></label>
                          <button
                            type="button"
                            onClick={showDcDetails}
                            style={{
                              background: 'none',
                              color: 'blue',
                              border: 'none',
                              padding: '0',
                              cursor: 'pointer',
                              textDecoration: 'underline',
                            }}
                          >
                            DELIVERY SUMMARY
                          </button>
                        </>
                      ) : null}
                    </div>
                  </Col>
                </Row>

                <Row className="mx-0">
                  <Col xl={12} lg={12} md={12} className="px-0">
                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary mb-3 form-control-panel form-cube-meta-panel w-100">
                      <Row className="form-fields-grid-2x2 mx-0 w-100">
                        <Col md={6} className="px-2">
                          <label htmlFor="casting_dt" className="form-group col-sm-4 text-right">Casting Date</label>
                          <input
                            id="casting_dt"
                            type="date"
                            className="form-control col-sm-8 mandatory-form-control"
                            name="casting_dt"
                            required
                            readOnly
                            style={{ backgroundColor: '#fff', cursor: 'not-allowed' }}
                            value={inputs.casting_dt || ""}
                          />
                        </Col>
                        <Col md={6} className="px-2">
                          <label htmlFor="cement_type" className="form-group col-sm-4 text-right">Cement Type</label>
                          <input type="text" className="form-control col-sm-8" id="cement_type" name="cement_type" onChange={handleChange} value={inputs.cement_type || ""} />
                        </Col>
                        <Col md={6} className="px-2">
                          <label htmlFor="cement_content" className="form-group col-sm-4 text-right">Cem Content</label>
                          <input type="text" className="form-control col-sm-8" id="cement_content" name="cement_content" onChange={handleChange} value={inputs.cement_content || ""} />
                        </Col>
                        <Col md={6} className="px-2">
                          <label htmlFor="technician_name" className="form-group col-sm-4 text-right">Technician Name</label>
                          <input type="text" className="form-control col-sm-8" name="technician_name" id="technician_name" onChange={handleChange} value={inputs.technician_name || ""} />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <CubeTestReportAgePanel
                  visible={agePanelVisible}
                  rowsData={rowsData}
                  noOfMouldsCasted={inputs.no_of_moulds}
                  onAddRow={addTableRows}
                  onDeleteRow={deleteTableRows}
                  onChangeRow={handletableChange}
                  onGenerateRow={generateCubeRowsForAgeRow}
                />

                <div className="form-row  shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue container table-responsive">
                  <table className="table-bordered table-responsive searchTable table order-list" id="myTable" style={{textAlign:"center",borderRadius:"10px",backgroundColor:"RGB(188,232,253)"}}>
                    <thead>
                      <tr>
                        <th  style={{verticalAlign:"middle",display:"None"}}>Id</th>
                        <th  style={{verticalAlign:"middle",display:"None"}}>no_of_rows</th>
                        <th  style={{verticalAlign:"middle"}}>Sl No</th>
                        <th  style={{verticalAlign:"middle", minWidth:"220px", whiteSpace:"nowrap"}}>Cube Id</th>
                        <th  style={{verticalAlign:"middle"}}>Age</th>
                        <th  style={{verticalAlign:"middle"}}>Testing Date</th>
                        <th  style={{verticalAlign:"middle"}}>Weight(gms)</th>
                        <th  style={{verticalAlign:"middle"}}>Dimension(mm)</th>
                        <th  style={{verticalAlign:"middle"}}>Area mm2</th>
                        <th  style={{verticalAlign:"middle"}}>Reference Value</th>
                        <th  style={{verticalAlign:"middle"}}>Max Load(kn)</th>
                        <th  style={{verticalAlign:"middle"}}>Strength(mpa)</th>
                        <th  style={{verticalAlign:"middle"}}>Average Strength(mpa)</th>
                        <th  style={{verticalAlign:"middle",display:"None"}}>Difference</th>
                        <th  style={{verticalAlign:"middle"}}>Customer Weight(gms)</th>
                        <th  style={{verticalAlign:"middle"}}>Customer Max Load(kn)</th>
                        <th  style={{verticalAlign:"middle"}}>Customer Strength(mpa)</th>
                        <th  style={{verticalAlign:"middle"}}>Customer Average Strength2(mpa)</th>
                        <th  style={{verticalAlign:"middle",display:"None"}}>Customer Difference</th>
                        <th  style={{verticalAlign:"middle"}}>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      <TableRowsCubeTestReportEdit
                        csrRows={csrRows}
                        handleChangeCsr={handleChangeCsr}
                        pendingAge={pendingAgeFromRoute || pendingTestAge}
                      />
                    </tbody>
                  </table>
                </div> 

                <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                  <label htmlFor="user_remarks" className="form-group col-sm-3 text-center">Remarks</label>
                  <textarea rows="2" cols="50" className="form-control col-sm-9" id="user_remarks" name="user_remarks" onChange={handleChange} value={inputs.user_remarks || ""}></textarea>
                </div>  
              </div>
                      
              <div className="footer text-center">
              <Button  type="submit" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} disabled={isClosed}>Update</Button> &nbsp;&nbsp;
                              <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={view}>View</Button>&nbsp;&nbsp;
                              <Button className="btn btn-twitter"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={Back}>Home</Button>&nbsp;&nbsp;
                  <Button className="btn btn-delete"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={onDeleteCubeTestReport}>Delete</Button>
              <Button className="btn btn-cancel"  type="button"style={{width:"100px",fontWeight:"bold"}} onClick={onCancelCubeTestReport}>Cancel</Button>&nbsp;&nbsp;
              </div>
            </form>
          </div>
        </div>
      </>
  );
}
export default CubeTestReportEdit;

